import { Contact, ContactType } from '@api/generated/graphql';
import { useOutboundCall } from '@api/hooks/useOutboundCall';
import useContactMethodsMenuContext from '@components/CustomerSearch/components/CustomerSearchResultItem/components/ContactMethodsMenu/context/useContactMethodsMenuContext';
import { useCallback } from 'react';
import { AgentCallerIdConfirmationModal } from '../CallConfirmationModal/AgentCallerIdConfirmationModal';

export interface CallConfirmationModalProps {
  contact: Contact;
  onClose: () => void;
  customTaskAttributes?: Record<string, unknown>;
  customer: {
    customerName?: string;
    tenantId: string;
    customerId: string;
  };
}

export const CallConfirmation = ({
  contact,
  onClose,
  customTaskAttributes,
  customer,
}: CallConfirmationModalProps) => {
  const { customerName, tenantId, customerId } = customer || {};
  const { setIsContactsMenuOpen } = useContactMethodsMenuContext();
  const { outboundCall } = useOutboundCall();

  const onCall = useCallback(
    async (callerId: string) => {
      onClose();
      if (
        contact.type === ContactType.MobilePhone ||
        contact.type === ContactType.Phone
      ) {
        await outboundCall({
          callerNumber: callerId,
          phoneNumber: contact.value,
          customerName,
          customerId,
          tenantId,
          customTaskAttributes,
        });
        // In some cases, CallConfirmationModal will be opened from ContactMethodsMenu, so we need to close it.
        // Below line will do nothing if this component is not used in ContactMethodsMenu and it's ContactMethodsMenuContext, setIsContactsMenuOpen will be undefined in these cases.
        setIsContactsMenuOpen?.(false);
      }
    },
    [
      contact,
      onClose,
      customerId,
      customerName,
      customTaskAttributes,
      tenantId,
      setIsContactsMenuOpen,
      outboundCall,
    ],
  );

  return (
    <AgentCallerIdConfirmationModal
      customerName={customerName}
      onClose={onClose}
      onCall={onCall}
      tenantId={tenantId}
      contact={contact}
    />
  );
};
